import React, { useState } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import { SubscribeTestProps } from '.';
import Checkout from './Checkout';
import OfferSelection from './OfferSelection';

enum SubscribePage {
  OfferSelection = 1,
  Checkout = 2,
}

const Content = ({ offers, reporters, ypOffer }: SubscribeTestProps) => {
  const { Track } = useEventTracking({ page: Page.SubscribeTest });
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [currentPage, setCurrentPage] = useState(SubscribePage.OfferSelection);

  return (
    <Track>
      {currentPage === SubscribePage.OfferSelection && (
        <OfferSelection
          onOfferClick={() => setCurrentPage(SubscribePage.Checkout)}
          offers={offers}
          reporters={reporters}
          setSelectedOffer={setSelectedOffer}
          ypOffer={ypOffer}
        />
      )}
      {currentPage === SubscribePage.Checkout && (
        <Checkout
          onBackClick={() => setCurrentPage(SubscribePage.OfferSelection)}
          selectedOffer={selectedOffer}
          presentedOfferCodes={offers.map((offer) => offer.code)}
        />
      )}
    </Track>
  );
};

export default Content;
